import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { IgoMeasurerModule } from '@ximple/igo2-geo';

import { MeasurerToolComponent } from './measurer-tool.component';

/**
 * @ignore
 */
@NgModule({
  imports: [
    IgoMeasurerModule
  ],
  declarations: [MeasurerToolComponent],
  exports: [MeasurerToolComponent],
  entryComponents: [MeasurerToolComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IgoAppMeasurerToolModule {}
